/* OREVA — comportamenti delle sezioni home: tab modelli, barra acquisto fissa, video clienti. */

if (!customElements.get('ov-tabs')) {
  class OvTabs extends HTMLElement {
    connectedCallback() {
      this._onClick = (event) => {
        const tab = event.target.closest('[data-ov-tab]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.ovTab);
      };
      this._onBlockSelect = (event) => {
        if (this.querySelector(`[data-ov-panel="${event.detail.blockId}"]`)) this.activate(event.detail.blockId);
      };
      this.addEventListener('click', this._onClick);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    activate(id) {
      this.querySelectorAll('[data-ov-tab]').forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.ovTab === id));
      });
      this.querySelectorAll('[data-ov-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.ovPanel === id);
      });
    }
  }
  customElements.define('ov-tabs', OvTabs);
}

if (!customElements.get('ov-sticky-bar')) {
  class OvStickyBar extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-design-mode')) return;
      this.offset = parseInt(this.dataset.offset || '700', 10);
      this._onScroll = this.update.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (!this._onScroll) return;
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    update() {
      const y = window.scrollY;
      const nearEnd = window.innerHeight + y > document.documentElement.scrollHeight - 480;
      this.classList.toggle('is-visible', y > this.offset && !nearEnd);
    }
  }
  customElements.define('ov-sticky-bar', OvStickyBar);
}

/* Un solo video cliente alla volta */
document.addEventListener('play', (event) => {
  const video = event.target;
  if (!(video instanceof HTMLVideoElement) || !video.closest('[data-ov-clips]')) return;
  document.querySelectorAll('[data-ov-clips] video').forEach((other) => {
    if (other !== video) other.pause();
  });
}, true);
/* OREVA — Checkout Funnelish (02-11-2026)
Se nel carrello c'è SOLO la Coppia OREVA Pro (quantità 1), il bottone del carrello porta al checkout Funnelish.
Se nel carrello c'è altro (accessori, quantità 2+), resta il checkout Shopify normale.
Porta con sé utm e fbclid della prima visita, per non perdere l'attribuzione Meta. */
(function () {
if (window.__ovFunnelish) return; window.__ovFunnelish = true;
var FUNNELISH = 'https://offerta.orevaitalia.com/checkout';
var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'];
function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
try {
var q = new URLSearchParams(location.search), found = {};
KEYS.forEach(function (k) { if (q.get(k)) found[k] = q.get(k); });
if (Object.keys(found).length) store('ov_params', JSON.stringify(found));
} catch (e) {}
function target() {
var url = FUNNELISH, saved = {};
try { saved = JSON.parse(store('ov_params') || '{}'); } catch (e) {}
var qs = Object.keys(saved).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(saved[k]); }).join('&');
return qs ? url + '?' + qs : url;
}
function onlyOrevaPro(cart) {
if (!cart || !cart.items || !cart.items.length) return false;
var qty = 0;
for (var i = 0; i < cart.items.length; i++) {
if (cart.items[i].handle !== 'oreva-pro') return false;
qty += cart.items[i].quantity;
}
return qty === 1;
}
var passThrough = false;
var SEL = '#kaching-cart__checkout-button, button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';
function isCheckoutBtn(e) {
var path = e.composedPath ? e.composedPath() : [e.target];
for (var i = 0; i < path.length; i++) {
var el = path[i];
if (el && el.matches && el.matches(SEL)) return el;
}
return null;
}
window.addEventListener('click', function (e) {
if (passThrough) return;
var btn = isCheckoutBtn(e);
if (!btn) return;
e.preventDefault(); e.stopImmediatePropagation();
var done = false;
function fallback() { if (done) return; done = true; passThrough = true; btn.click(); setTimeout(function () { passThrough = false; }, 1500); }
setTimeout(fallback, 2500);
fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
if (done) return;
if (onlyOrevaPro(cart)) { done = true; window.location.href = target(); }
else fallback();
}).catch(fallback);
}, true);
})();
